import { userTypes } from 'config/config';
import { Route, Routes } from 'react-router-dom';
import ContractManagement from 'screens/contractManagement/ContractManagement';
import NewContract from 'screens/contractManagement/newContract/NewContract';
import DashboardPage from 'screens/dashboard/Dashboard';
import PreferenceIndividual from 'screens/individual/PreferenceIndividual';
import InvoiceManagement from 'screens/invoice/InvoiceManagement';
import ChangePassword from 'screens/password/ChangePassword';

import ProtectedRoute from './ProtectedRoute';
import Layout from '../components/Layout';

const IndividualRoutes = () => (
  <ProtectedRoute allowedRoles={[userTypes.individual]}>
    <Layout>
      <Routes>
        <Route path="dashboard/*" element={<DashboardPage />} />
        <Route path="preference" element={<PreferenceIndividual />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="/contract-management" element={<ContractManagement />} />
        <Route
          path="/contract-management/new-contract"
          element={<NewContract />}
        />
        <Route path="/invoice-management" element={<InvoiceManagement />} />
        {/* <Route
          path="/invoice-management/invoice/:invoiceId"
          element={<ViewInvoice />}
        /> */}
      </Routes>
    </Layout>
  </ProtectedRoute>
);
export default IndividualRoutes;
